import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface IChallengeEmailsModalState {
  visible: boolean;
}

const challengeEmailsModal: Module<IChallengeEmailsModalState, RootState> = {
  namespaced: true,
  state: () => ({
    visible: false,
  }),
  mutations: {
    setValue(state, value: IChallengeEmailsModalState): void {
      Object.assign(state, value);
    },
  },
  getters: {
    visible: state => state.visible,
  },
};

export default challengeEmailsModal;
